import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { PostPublication } from '../../../telegram-forum/model';
import { CreatePostDto, PostDto, PostImage } from '../../posts-table/model';

const POST = `/api/admin/posts`;

interface UpdateParams {
	uuid: string;
	request: Partial<CreatePostDto>;
}

export const useCreatePost = () => {
	const queryClient = useQueryClient();

	return useMutation<PostDto, any, CreatePostDto>(
		'posts',
		async request => {
			const { data: response } = await axios.post(`${POST}/`, request);
			return response;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('posts');
			},
		}
	);
};

export const useUploadPostImage = () => {
  return useMutation<PostImage, any, File>(
    'posts',
    async (file: File) => {
      const formData = new FormData();
      formData.append('image', file);

      const { data: response } = await axios.post(`${POST}/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response;
    }
  );
};

export const useUpdatePost = () => {
	const queryClient = useQueryClient();

	return useMutation<PostDto, any, UpdateParams>(
		'posts',
		async ({ uuid, request }) => {
			const { data: response } = await axios.patch(`${POST}/${uuid}`, request);
			return response;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('posts');
			},
		}
	);
};

export const useDeletePost = () => {
	const queryClient = useQueryClient();

	return useMutation<PostDto, any, string>(
		'posts',
		async uuid => {
			const { data: response } = await axios.delete(`${POST}/${uuid}`);
			return response;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('posts');
			},
		}
	);
};

/**
 * Публикация поста в топик Telegram-группы.
 * Ручка ставит задачу в очередь и отвечает сразу — статус будет pending,
 * пока фоновая задача не отправит сообщение.
 */
export const usePublishPost = () => {
	const queryClient = useQueryClient();

	return useMutation<PostPublication, any, string>(
		'post-publication',
		async uuid => {
			const { data: response } = await axios.post(`${POST}/${uuid}/publish`);
			return response;
		},
		{
			onSuccess: (_data, uuid) => {
				queryClient.invalidateQueries(['post-publication', uuid]);
				// В списке постов статус публикации приходит вместе с постом
				queryClient.invalidateQueries('posts');
			},
		}
	);
};
